import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=f2ba0f44&scoped=true"
import script from "./GeneralTab.vue?vue&type=script&lang=js"
export * from "./GeneralTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralTab.vue?vue&type=style&index=0&id=f2ba0f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ba0f44",
  null
  
)

export default component.exports